export default {
    'sys_config':  `/system/config?lang=`,  //系统配置
    'sys_get_notice_list': `/notice/getNoticeList?lang=`, //获取系统公告列表
    'sys_get_banks': `/system/getBankList?lang=`, //获取银行列表
    'video_class': `/video/itemlist?lang=`,  //视频分类
    'video_get_info':  `/video/getVideoInfo?lang=`,  //视频分类
    'video_get_more_item': `/video/getVideoInfoItem?lang=`, //获取视频列表下的更多视频
    'lottery_class':   `/Lottery/itemlist?lang=`,  //彩票分类
    'lottery_hot': `/Lottery/hotLottery?lang=`,  //热门彩票
    'lottery_list': `/Lottery/lotteryList?lang=`,  //彩票列表
    'lottery_get_info': `/Lottery/getLotteryInfo?lang=`,  //获取彩票信息
    'lottery_get_one_list': `/Lottery/getLotteryOneList?lang=`,  //获取单彩票的开奖结果
    'lottery_get_peilv':   `/Lottery/getLotteryPeilv?lang=`,  //获取单彩票的赔率
    'video_list':  `/video/getVideoList?lang=`,  //视频列表
    'member_login': `/member/doLogin?lang=`, //用户登录
    'member_register': `/member/doRegister?lang=`, //用户注册
    'base_info': `/system/base?lang=`,        //基本信息获取
    'user_info': `/member/getUserInfo?lang=`,   //用户信息获取
    'user_header_img': `/member/uploadHeaderImg?lang=`, //更新用户头像
    'user_get_bank': `/member/getUserBankInfo?lang=`, //获取用户的银行卡信息
    'user_get_withdraw_list': `/member/getUserWithdrawList?lang=`, //获取用户提现记录
    'user_get_game_list': `/member/getUserGameList?lang=`, //获取用户提现记录
    'user_set_bank':   `/member/setBank?lang=`, //更新用户银行卡
    'user_set_name': `/member/setName?lang=`, //更新用户姓名
    'user_set_sex': `/member/setSex?lang=`, //更新用户姓名
    'user_set_paypw': `/member/setPayPassword?lang=`, //更新用户支付密码
    'user_set_loginpw': `/member/setLoginPassword?lang=`, //更新用户登录密码
    'user_get_withdraw_role': `/member/getUserWithdrawRole?lang=`, //获取用户提现规则
    'user_get_personalreport': `/member/getPersonalreport?lang=`, //获取用户报表
    'user_set_withdraw': `/member/setUserWirhdraw?lang=`, //获取用户提现规则
    'game_place_order': `/game/placeOrder?lang=`, //用户提交订单


}